export const copyText = async (text: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text)
  } catch (error) {
    console.error('Failed to copy text to clipboard:', error)
    throw error // Re-throw to allow calling code to handle the error
  }
}
